module.exports = __webpack_public_path__ + "static/Steps-Mono-Thin-457221d1abd2adcb9152e3b9e5bb6224.ttf";